import { X, Download, ExternalLink } from "lucide-react";

/**
 * Inline preview modal for PDF (or other browser-viewable) attachments.
 * Uses iframe to render the file inline without downloading.
 */
export default function PdfPreviewModal({ attachment, url, onClose }) {
  if (!attachment || !url) return null;
  return (
    <div
      className="fixed inset-0 z-[55] bg-slate-900/70 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="pdf-preview-modal"
    >
      <div
        className="bg-white border border-slate-200 w-full max-w-5xl h-[90vh] flex flex-col shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="border-b border-slate-200 px-5 py-3 flex items-center justify-between shrink-0">
          <div className="min-w-0 flex-1">
            <div className="mono text-[10px] uppercase tracking-widest text-slate-400">
              Preview Dokumen
            </div>
            <div className="font-semibold text-sm truncate">
              {attachment.original_name}
            </div>
          </div>
          <div className="flex items-center gap-1 shrink-0">
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              data-testid="pdf-open-newtab"
              className="p-2 border border-slate-300 hover:border-slate-900"
              title="Buka di tab baru"
            >
              <ExternalLink className="w-4 h-4 text-slate-600" />
            </a>
            <a
              href={url}
              download={attachment.original_name}
              data-testid="pdf-download"
              className="p-2 border border-slate-300 hover:border-slate-900"
              title="Unduh"
            >
              <Download className="w-4 h-4 text-slate-600" />
            </a>
            <button
              data-testid="pdf-close"
              onClick={onClose}
              className="p-2 hover:bg-slate-100"
              title="Tutup"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Iframe */}
        <div className="flex-1 min-h-0 bg-slate-100">
          <iframe
            src={url}
            title={attachment.original_name}
            className="w-full h-full border-0"
            data-testid="pdf-iframe"
          />
        </div>
      </div>
    </div>
  );
}
